import React, { Fragment, useState, useEffect } from "react";
// import { format, formatISO, parseISO } from "date-fns";
import Textarea from "react-textarea-autosize";

import difference from "lodash.difference";
import intersection from "lodash.intersection";

import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import {
  dark,
  solarizedlight,
} from "react-syntax-highlighter/dist/esm/styles/prism";

import useStateWithLocalstorage from "./hooks/useStateWithLocalstorage";

import CTA from "./components/CTA";

const normalDefault = `<a href="#" class="whitespace-no-wrap ml-8 py-4 px-1 border-b-2 border-transparent font-medium text-sm leading-5 text-gray-500 hover:text-gray-700 hover:border-gray-300 focus:outline-none focus:text-gray-700 focus:border-gray-300">
  Company
</a>`;

const activeDefault = `<a href="#" class="whitespace-no-wrap ml-8 py-4 px-1 border-b-2 border-indigo-500 font-medium text-sm leading-5 text-indigo-600 focus:outline-none focus:text-indigo-800 focus:border-indigo-700" aria-current="page">
  Team Members
</a>`;

export default () => {
  const [normal, setNormal] = useStateWithLocalstorage(
    "rth:normal",
    normalDefault
  );
  const [active, setActive] = useStateWithLocalstorage(
    "rth:active",
    activeDefault
  );

  // const normal = normalClasses.split(" ");
  // const active = activeClasses.split(" ");
  // const normalClasses =
  const nMatch = normal.match(/class="([^"]+)"/);
  const nClasses = nMatch ? nMatch[1].split(" ") : [];

  const aMatch = active.match(/class="([^"]+)"/);
  const aClasses = aMatch ? aMatch[1].split(" ") : [];

  let tagName = "div";
  const tagMatch = normal.match(/<(\w+)\s/);
  if (tagMatch) tagName = tagMatch[1];

  const common = intersection(nClasses, aClasses);
  const onlyNormal = difference(nClasses, aClasses);
  const onlyActive = difference(aClasses, nClasses);
  let code = `<${tagName}\n  className={`;
  code += "`";
  code += '${isActive ? "' + onlyActive.join(" ");
  code += '" : "' + onlyNormal.join(" ");
  code += '"} ';
  code += common.join(" ");
  code += "`";
  code += `}\n>\n  {children}\n</${tagName}>`;

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-12">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-4xl mt-4 mb-2">
          React Tailwind Helpers{" "}
          <span className="text-2xl text-gray-500">
            by{" "}
            <a className="hover:underline" href="https://twitter.com/cgenco">
              @cgenco
            </a>
          </span>
        </h1>
        <label
          className="block text-gray-700 text-sm font-bold mb-2"
          for="active"
        >
          Normal element
        </label>
        <Textarea
          value={normal}
          onChange={(e) => setNormal(e.target.value)}
          id="active"
          className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
        />
        <label
          className="block text-gray-700 text-sm font-bold mb-2 mt-4"
          for="active"
        >
          Active element
        </label>
        <Textarea
          value={active}
          onChange={(e) => setActive(e.target.value)}
          id="active"
          className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
        />

        <SyntaxHighlighter
          language="javascript"
          style={solarizedlight}
          wrapLines={true}
        >
          {code}
        </SyntaxHighlighter>
        <p className="p-4 bg-yellow-100">
          Want this for Vue instead of React? Check out{" "}
          <a
            className="text-blue-500 hover:underline"
            href="https://tailwindui-helper.iantrent.com/"
          >
            Vue.js Tailwind UI Helper
          </a>{" "}
          by{" "}
          <a
            className="text-blue-500 hover:underline"
            href="https://twitter.com/ianmtrent"
          >
            @ianmtrent
          </a>
        </p>
        <CTA />
        <pre>{JSON.stringify({ common, onlyActive, onlyNormal }, null, 2)}</pre>
      </div>
    </div>
  );
};
